import { normalizeAppVersionTimestamp } from '@app/shared/utils/appVersion';

declare const __APP_VERSION__: string;
declare const __APP_VERSION_TIMESTAMP__: string;
declare const __APP_VERSION_REPORTED__: boolean;

export const APP_VERSION = __APP_VERSION__;
export const APP_VERSION_TIMESTAMP = normalizeAppVersionTimestamp(
  __APP_VERSION_TIMESTAMP__
);
// false у локальной сборки: она не отправляет версию в HeaderFrontVersion.
export const IS_APP_VERSION_REPORTED = __APP_VERSION_REPORTED__;
